import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { previousSimulationStep } from 'store/simulation/actions/switchSimulationStep'
import { Store } from 'store/types'
import { NavigationButtonProps as Props } from './types'
import { SimulationSteps } from 'features/simulation/types'
import styles from '../../Simulation.module.scss'
import classNames from 'classnames'
import { ButtonTypes } from 'components/button/types'
import Button from 'components/button/Button'

const NavigationButtons: FC<Props> = ({ nextDisabled, onNextClick }) => {
  // REDUX STORE
  const { currentStep } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // i18n
  const { t } = useTranslation('simulation')

  return (
    <div className={classNames(styles['action-buttons'], 'margin-bottom-l')}>
      {currentStep !== SimulationSteps.POSTAL_CODE && (
        <div>
          <Button
            onClick={() => dispatch(previousSimulationStep())}
            type={ButtonTypes.TERNARY}
            extraClasses="margin-bottom-s margin-right-m"
          >
            {t('previous', 'Vorige')}
          </Button>
        </div>
      )}

      <div>
        <Button isDisabled={nextDisabled} onClick={onNextClick} extraClasses="margin-bottom-s" withGradient>
          {t('next', 'Volgende')}
        </Button>
      </div>
    </div>
  )
}

export default NavigationButtons
